enum BondStatusKey {
  BOND_STATUS_BONDED = 'BOND_STATUS_BONDED',
  BOND_STATUS_UNBONDING = 'BOND_STATUS_UNBONDING',
  BOND_STATUS_UNBONDED = 'BOND_STATUS_UNBONDED',
}

export default BondStatusKey;
